module.exports = __webpack_public_path__ + "img/email.04e3663d.svg";